import { render, staticRenderFns } from "./EditGiftForList.vue?vue&type=template&id=65c2e760&scoped=true&"
import script from "./EditGiftForList.ts?vue&type=script&lang=ts&"
export * from "./EditGiftForList.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c2e760",
  null
  
)

export default component.exports